module.exports = __webpack_public_path__ + "static/media/confetti1.c356de08.gif";